
module.exports = (function () {
  'use strict';

  var breakpoint = window.matchMedia('(min-width: 1200px)');

  var init = function () {
    // Menu open / close
    var pageNav  = document.getElementById('page-nav'),
        navOpen  = document.getElementById('page-nav-open');

    // sanity checks
    if (pageNav === null || pageNav === undefined)  return;
    if (navOpen === null || navOpen === undefined) return;

    navOpen.addEventListener('click', function() {
      classie.add(pageNav, 'active');
      classie.add(document.body, 'overlay-active');
    }, true);
    handleMobileNavCloseAction();

    // keep an eye on viewport size changes
    breakpoint.addListener(handleResize);
    observerAndCall([].slice.call(document.querySelectorAll('[data-client-render-menu]')), handleResize);
    handleResize();

    if(typeof window.__reece_render_header__ === 'function') {
      //has client side user menu rendering
      observerAndCall([document.querySelector('[data-reece-mustache-template-id="mobile-user-nav"]')], function() {
        handleAccountDropdown();
        handleMobileNavCloseAction();
      });
    }
    handleAccountDropdown();
    
  };

  function observerAndCall(eles, callback) {
    eles.forEach(ele => {
      var observer = new MutationObserver(callback);
      observer.observe(ele, {
        childList: true
      });
    })
  }

  var handleMobileNavCloseAction = function() {
    var pageNav  = document.getElementById('page-nav');
    var navClose = document.getElementById('page-nav-close');
    if (pageNav === null || pageNav === undefined)  return;
    if (navClose === null || navClose === undefined) return;
    navClose.addEventListener('click', function() {
      classie.remove(pageNav, 'active');
      classie.remove(document.body, 'overlay-active');
    }, true);
  };

  // Function handle navigation resize
  var handleResize = function() {
    var nav = document.querySelector('.page-nav-main');
    var navLevel = document.querySelectorAll('.page-nav-level');
    var navLevelBack  = document.querySelectorAll('.page-nav-level__back-btn');
    var navLevelItems = document.querySelectorAll('.page-nav-link');

    var navLevel1UL = document.querySelectorAll('.page-nav-level-1__ul--type-1');
    var navLevel0Items = document.querySelectorAll('.page-nav-level-0__li');
    var navLevel1Items = document.querySelectorAll('.page-nav-level-1__li--type-1');
    var navLevel1 = document.querySelectorAll('.page-nav-level-1');
    var navLevel2 = document.querySelectorAll('.page-nav-level-2');

    // Reset page navigation height, active state
    document.querySelector('.page-nav-main').style.height = 'auto';
    navLevel.forEach(function(nav) {
      classie.remove(nav, 'active');
    });
    navLevel1Items.forEach(function(nav) {
      classie.remove(nav, 'active');
    });

    // For larger screen size
    if (breakpoint.matches === true) {
      // Disable slider
      // Remove onclick event from mobile
      if(navLevelItems !== null) {
        navLevelItems.forEach(function(element) {
          element.onclick = null;
        });
      }
      if(navLevelBack !== null) {
        navLevelBack.forEach(function(element) {
          element.onclick = null;
        });
      }

      if(navLevel0Items !== null) {
        // Base level navigation
        navLevel0Items.forEach(function(element0) {
          var currentSubNavItems = element0.querySelectorAll('.page-nav-level-1__li--type-1');

          // Set first level 1 navigation open as default when loaded
          if(element0.querySelector('.page-nav-level-1__li--type-1') !== null) {
            classie.add(element0.querySelector('.page-nav-level-1__li--type-1'), 'active');
          }
          if(element0.querySelector('.page-nav-level-2') !== null) {
            classie.add(element0.querySelector('.page-nav-level-2'), 'active');
          }

          var currentLevel0TimeoutHandler = null;

          // Add mouse enter event for base level navigation
          element0.onmouseenter = function onLevel0ItemOpen(event) {
            var target = event.currentTarget;
            clearTimeout(currentLevel0TimeoutHandler);
            currentLevel0TimeoutHandler = setTimeout(() => expandLevel0ItemMenu(target), 100);
          }

          function expandLevel0ItemMenu(item) {
            var currentSubNav1 = item.querySelector('.page-nav-level-1');
            var currentSubNav2 = item.querySelector('.page-nav-level-2');
            var currentSubNav1Ul = item.querySelector('.page-nav-level-1__ul--type-1');

            // Remove active class from other item
            navLevel0Items.forEach(function(elem) {
              classie.remove(elem, 'active');
            });
            // Add active class to current menu item and submenu
            classie.add(item, 'active');
            if(currentSubNav1 !== null) {
              classie.add(currentSubNav1, 'active');
            }
  
            // Init the navheight on first load
            if(currentSubNav1Ul !== null && currentSubNav2 !== null) {
              var navHeight1Num = (currentSubNav1Ul !== null) ? currentSubNav1Ul.querySelector('li').offsetHeight * currentSubNav1Ul.children.length : 300; //some magic number, should not matter though
              var navHeight1 = (currentSubNav1Ul !== null) ? currentSubNav1Ul.querySelector('li').offsetHeight * currentSubNav1Ul.children.length + 'px' : 'auto';
              var navHeight2Num = (currentSubNav2 !== null) ? currentSubNav2.offsetHeight : 300; //some magic number, should not matter though
              var navHeight2 = (currentSubNav2 !== null) ? currentSubNav2.offsetHeight + 'px' : 'auto';
              if(navHeight1Num >= navHeight2Num) {
                currentSubNav1Ul.style.height = navHeight1;
                currentSubNav2.style.height = navHeight1;
              }
              else {
                currentSubNav1Ul.style.height = navHeight2;
                currentSubNav2.style.height = navHeight2;
              }
            }
          }

          // Add mouse leave event for base level navigation
          element0.onmouseleave = function (event) {
            clearTimeout(currentLevel0TimeoutHandler);
            var item = event.currentTarget;
            var currentSubNav1 = item.querySelector('.page-nav-level-1');
            // Remove active class from other item
            navLevel0Items.forEach(function(elem) {
              classie.remove(elem, 'active');
            });
            if(currentSubNav1 !== null) {
              classie.remove(currentSubNav1, 'active');
            }
          };
          
          if(currentSubNavItems !== null) {
            currentSubNavItems.forEach(function(element1) {
              element1.onmouseenter = function (event) {
                var item1 = event.currentTarget;
                var currentSubNav1UL = _findAncestor(item1, 'page-nav-level-1__ul--type-1');
                var currentSubNav2 = currentSubNav1UL.querySelectorAll('.page-nav-level-2');
                var currentSubNav2Item = item1.querySelector('.page-nav-level-2');
                var navHeight1Num = (currentSubNav1UL !== null) ? item1.offsetHeight * currentSubNav1UL.children.length : 300;
                var navHeight1 = (currentSubNav1UL !== null) ? item1.offsetHeight * currentSubNav1UL.children.length + 'px' : 'auto';
                var navHeight2Num = (currentSubNav2Item !== null) ? currentSubNav2Item.offsetHeight : 300;
                var navHeight2 = (currentSubNav2Item !== null) ? currentSubNav2Item.offsetHeight + 'px' : 'auto';
                // If no sub nav reset nav height
                if(currentSubNav1UL !== null && navHeight2 == 'auto') {
                  currentSubNav1UL.style.height = navHeight2;
                }
                if(currentSubNav1UL !== null && currentSubNav2Item !== null) {
                  if(navHeight1Num >= navHeight2Num) {
                    currentSubNav1UL.style.height = navHeight1;
                    currentSubNav2Item.style.height = navHeight1;
                  }
                  else {
                    currentSubNav1UL.style.height = navHeight2;
                    currentSubNav2Item.style.height = navHeight2;
                  }
                }
      
                // Remove active class from other item 
                currentSubNavItems.forEach(function(elem) {
                  classie.remove(elem, 'active');
                });
                // Remove active class from all level 2 nav 
                currentSubNav2.forEach(function(elem) {
                  classie.remove(elem, 'active');
                });
                // Add active class to current menu submenu
                classie.add(item1, 'active');
                if(currentSubNav2Item !== null) {
                  classie.add(currentSubNav2Item, 'active');
                }
              };
            });
          }//end if
        });//end foreach
      }//end if(navLevel0Items !== null)
    }//end if breakpoint.matches
    // For smaller screen size
    else if (breakpoint.matches === false) {
      // Reset navigation height
      if(navLevel1UL !== null) {
        navLevel1UL.forEach(function(element) {
          element.style.height = 'auto';
        });
      }
      if(navLevel2 !== null) {
        navLevel2.forEach(function(element) {
          element.style.height = 'auto';
        });
      }

      // Remove mouse hover event from desktop
      if(navLevel0Items !== null) {
        navLevel0Items.forEach(function(element) {
          element.onmouseenter = null;
          element.onmouseleave = null;
        });
      }
      if(navLevel1Items !== null) {
        navLevel1Items.forEach(function(element) {
          element.onmouseenter = null;
          element.onmouseleave = null;
        });
      }

      // Handle user click on menu item on each level
      if(navLevelItems !== null) {
        navLevelItems.forEach(function(element) {
          element.onclick = function (event) {
            
            if(event.currentTarget && event.currentTarget.id === 'Max-Megamenu') {
              //disable click and open url in max mega menu
              event.preventDefault();
            }

            var item = event.currentTarget;
            var navLevelHeight = item.parentElement.querySelector('.page-nav-level');
            if(navLevelHeight !== null) {
              // Set nav level height
              nav.style.height = navLevelHeight.offsetHeight + 'px';
              // Add acitve class to the nav level
              classie.add(item.parentElement.querySelector('.page-nav-level'), 'active');
            }
          };
        });
      }

      // Handle user click on back btn on mobile
      if(navLevelBack !== null) {
        navLevelBack.forEach(function(element) {
          element.onclick = function (event) {
            var item = event.currentTarget;
            var navLevelHeight = _findAncestor(_findAncestor(item, 'page-nav-level'), 'page-nav-level').offsetHeight;
            // Set nav level height
            nav.style.height = navLevelHeight + "px";
            // Remove active class from the nav level
            classie.remove(_findAncestor(item, 'page-nav-level'), 'active');
          };
        });
      }
    }//end of else breakpoint.match
  };

  // Function handle mobile navigation account dropdown
  var handleAccountDropdown = function() {
    // Account drop down
    var initalNavTopHeight = 0;
    var navTop = document.querySelector('.page-nav-top');
    var navTopP1 = document.querySelector('.page-nav-top__group');
    var accountNavs = document.querySelectorAll('.page-nav-top__link-group-li');
    var accountSubNavs = document.querySelectorAll('.page-nav-top__link-sub-group');
    // This contains both desktop and mobile account nav item.
    var accountList = document.querySelectorAll('.account-list-item');

    if(navTop !== null) {
      // Get height of the display none element
      navTop.style.height = null; //IMPORTANT!!! RESETING height so that it can be called multiple times
      classie.add(navTop, '_active');
      initalNavTopHeight = navTop.offsetHeight;
      classie.remove(navTop, '_active');
      // Set inital height for mobile nav top part
      navTop.style.height = initalNavTopHeight + 'px';
    }

    if(accountNavs !== null) {
      accountNavs.forEach(function(element) {
        const pageNavTopLink = element.querySelector('.page-nav-top__link');
        pageNavTopLink && ( pageNavTopLink.onclick = function (event) {
          var item = event.currentTarget.parentElement;
          var accountSubNav = item.querySelector('.page-nav-top__link-sub-group');

          // Check if there is sub navigation
          if(accountSubNav !== null) {
            // Check if the menu is active
            if (item.classList.contains('active')) {
              classie.remove(item, 'active');
              // Remove active class after centain timeframe so there won't be a blank space appear when slide toggle
              window.setTimeout(function () {
                classie.remove(accountSubNav, 'active');
              }, 300);
              // Set navTop height to inital height
              navTop.style.height = initalNavTopHeight + 'px';
            }
            else {
              // Remove all active state for all elements
              accountNavs.forEach(function(elem) {
                classie.remove(elem, 'active');
              });
              accountSubNavs.forEach(function(elem) {
                classie.remove(elem, 'active');
              });

              classie.add(item, 'active');
              classie.add(accountSubNav, 'active');

              var expandHeight = 0;
              // Total height of the account subnav (light grey section)
              accountSubNav.childNodes.forEach(function(el) {
                if(!isNaN(el.offsetHeight)) {
                  expandHeight += el.offsetHeight;
                }
              });

              // Set navTop height
              navTop.style.height = navTopP1.offsetHeight + expandHeight + 'px';
              accountSubNav.style.height = expandHeight + 'px';
            }
          }
          else {
            // Remove all active state for all elements
            accountNavs.forEach(function(elem) {
              classie.remove(elem, 'active');
            });
            navTop.style.height = initalNavTopHeight + 'px';
          }
        });
      });
    }//end if(accountNavs) !== null

    // Check for both desktop and mobile
    if(accountList !== null) {
      accountList.forEach(function(element) {
        element.onclick = function (event) {
          // Remove all active class in same level
          accountList.forEach(function(ele) {
            if(ele.parentNode)
            classie.remove(ele, 'active');
          });
          // Add active to clicked item
          classie.add(event.currentTarget, 'active');
        };
      });
    }
  };

  // Find parent element.
  var _findAncestor = function (el, cls) {
    while ((el = el.parentElement) && !el.classList.contains(cls));
    return el;
  };

  // https://gomakethings.com/how-to-get-the-closest-parent-element-with-a-matching-selector-using-vanilla-javascript/
  var _getClosest = function (elem, selector) {
    // Element.matches() polyfill
    if (!Element.prototype.matches) {
      Element.prototype.matches =
      Element.prototype.matchesSelector ||
      Element.prototype.mozMatchesSelector ||
      Element.prototype.msMatchesSelector ||
      Element.prototype.oMatchesSelector ||
      Element.prototype.webkitMatchesSelector ||
      function(s) {
          var matches = (this.document || this.ownerDocument).querySelectorAll(s),
              i = matches.length;
          while (--i >= 0 && matches.item(i) !== this) {}
          return i > -1;
      };
    }
  
    // Get the closest matching element
    for ( ; elem && elem !== document; elem = elem.parentNode ) {
      if ( elem.matches( selector ) ) return elem;
    }
    return null;
  };

  return {
    init: init
  };

}());
